import { createContext } from 'react';
import type { WhoAmIResponse } from '@carculate/api-client';

export interface AuthContextValue {
  user: WhoAmIResponse | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  /**
   * S021.5c §3.2 — whoami gaf 401 en het hervatten met het toestel-token kon NU niet (503,
   * netwerk). Geen reden om naar het inlogscherm te gaan: `ProtectedRoute` toont dan een
   * foutstaat met "Opnieuw proberen". Optioneel, zodat bestaande test-providers blijven werken.
   */
  resumeUnavailable?: boolean;
  /**
   * S021.5d §A.4 (G-1) — whoami kon niet worden opgehaald omdat er geen verbinding is (de query
   * is `paused`, of faalde met een `TypeError`). Alleen op `/monteur…` gebruikt: `ProtectedRoute`
   * laat de monteur-schil dan zelf beslissen (koude start met de bewaarde gegevens van vandaag),
   * in plaats van naar een inlogscherm te sturen waar offline niemand kan inloggen. Optioneel,
   * zodat bestaande test-providers blijven werken.
   */
  whoamiOffline?: boolean;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
